// All 24 targeted areas — must match exactly the name_ar values in areasConfig.js
// The AreaDetails page uses normalize() to compare, so spelling must align with areasConfig
export const targetedAreas = [
  "التجمع الخامس",
  "التجمع الاول",
  "التجمع الثالث",
  "مدينة نصر",
  "القطامية",
  "زهراء المعادي",
  "المعادي",
  "صقر قريش",
  "مصر الجديدة",
  "السلام",
  "شيراتون",
  "النزهة",
  "العباسية",
  "مدينتي",
  "الرحاب",
  "العبور",
  "المقطم",
  "العاصمة الإدارية",
  "أكتوبر",
  "الشيخ زايد",
  "اسكندرية",
  "الساحل الشمالي",
  "طريق السخنة",
  "طريق السويس",
];
